import React, {Component} from 'react'
import {HashRouter, Route, Switch} from 'react-router-dom'
import {isMobile} from 'react-device-detect'
import FlightsScreen from 'screens/flights/index'
import WeatherScreen from 'screens/weather/index'
import authenticate from 'shared/hoc/authentication/index'
import SigchartsScreen from 'screens/sigcharts/index'
import BriefingScreen from 'screens/briefing/index'
import LoginScreen from 'screens/login/index'
import NotFound from 'shared/components/ErrorPages/NotFound'
import NotSupported from '../shared/components/ErrorPages/NotSupported'
import appConfig from '../config/applicationConfig'

class AppContainer extends Component {

    render() {
        return isMobile && appConfig.blockMobile ?
            (<HashRouter>
                <Switch>
                    <Route path='*' component={NotSupported}/>
                </Switch>
            </HashRouter>) : (<HashRouter>
                <Switch>
                    <Route exact path='/' component={authenticate(FlightsScreen)}/>
                    <Route exact path='/flights' component={authenticate(FlightsScreen)}/>
                    <Route exact path='/briefing/:flightId' component={authenticate(BriefingScreen)}/>
                    <Route exact path='/sigcharts' component={authenticate(SigchartsScreen)}/>
                    <Route exact path='/weather' component={authenticate(WeatherScreen)}/>
                    <Route exact path='/login' component={LoginScreen}/>
                    <Route component={NotFound}/>
                </Switch>
            </HashRouter>)
    }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/shell/AppContainer.js